module.exports = __webpack_public_path__ + "img/img (43).4be150aa.jpg";